import { Chips, DataStatus, Separator } from 'platform/components';
import { HStack, VStack } from 'platform/foundation-tw';
import { intersection } from 'ramda';
import { isArray, isEmptyArray } from 'ramda-adjunct';
import { suffixTestId, useOnMount, type Nullish } from 'shared/web';
import { quickFiltersConst } from '../../constants/quickFilters';
import { useChoiceFilter } from '../../hooks/useChoiceFilter';
import { useFilterOnChipsChange } from '../../hooks/useFilterOnChipsChange';
import { useLazyChoiceFilterOptions } from '../../hooks/useLazyChoiceFilterOptions';
import type { EagFilterProps } from '../../types/EagFilterProps';
export type ChipsFilterProps = EagFilterProps & {
  columnKey: string;
  quickFilters?: Array<{
    value: string;
    label: string;
  }>;
};
const FILTER_VALUE_KEY = 'value';
export function ChipsFilter(props: ChipsFilterProps) {
  const rawModel = props.value[FILTER_VALUE_KEY] as string[] | string | Nullish;
  const [values, setValues] = useChoiceFilter({
    model: rawModel,
    onChange: newValue => {
      props.onChange({
        [FILTER_VALUE_KEY]: newValue
      });
    }
  });
  const {
    loadOptions,
    isLoading,
    options,
    errorMessage
  } = useLazyChoiceFilterOptions({
    columnKey: props.columnKey
  });
  const {
    onChipsChange
  } = useFilterOnChipsChange({
    setFilterValue: setValues,
    defaultValue: null
  });
  const isQuickFilterValue = intersection(isArray(values) ? values : [values], quickFiltersConst);
  const isControlDisabled = props.isDisabled;
  useOnMount(() => {
    void loadOptions();
  });
  return <VStack>
      {props.quickFilters && props.quickFilters.length > 0 && <>
          <HStack>
            <Chips isDisabled={props.isDisabled} value={isQuickFilterValue} options={props.quickFilters} onChange={onChipsChange} isMultiple={false} data-testid={suffixTestId('chips-filter-quickFilters', props)} isDeselectable />
          </HStack>
          <Separator />
        </>}
      <DataStatus isLoading={isLoading}>
        <Chips isDisabled={isControlDisabled} options={options} value={isEmptyArray(isQuickFilterValue) && isArray(values) ? values : null} onChange={setValues} isMultiple isDeselectable errorMessage={errorMessage} data-testid={suffixTestId('chips-filter', props)} />
      </DataStatus>
    </VStack>;
}